/*
 * PluginSelectionModal TemplateTile Messages
 *
 * This contains all the text for the TemplateTile component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.components.PluginSelectionModal.templateTile';

export default defineMessages({
  thumbnailPreview: {
    id: `${scope}.preview`,
    defaultMessage: 'preview',
  },
  thumbnailChoose: {
    id: `${scope}.choose`,
    defaultMessage: 'choose',
  },
});
